import { useState } from "react";

const LogoImage = ({
  logoName,
  logoId,
  className = "h-10 w-[120px]"
}) => {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  return (
    <div className={`relative ${className} flex items-center justify-center`}>
      {/* Skeleton */}
      {!loaded && !error && (
        <div className="absolute inset-0 bg-gray-200 animate-pulse rounded" />
      )}

      {/* Image */}
      {!error && (
        <img
          src={`${process.env.REACT_APP_API_URL}/logo-image/${logoId}`}
          alt={logoName || "logo-image"}
          className={`h-full w-full object-contain transition-opacity duration-300 ${
            loaded ? "opacity-100" : "opacity-0"
          }`}
          loading="lazy"
          onLoad={() => setLoaded(true)}
          onError={() => setError(true)}
        />
      )}
    </div>
  );
};

export default LogoImage;
